// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rX6m","content":"styles_content__2kMkn"};